import { render, staticRenderFns } from "./AdminContract2022List.vue?vue&type=template&id=50f6999d&scoped=true"
import script from "./AdminContract2022List.vue?vue&type=script&lang=js"
export * from "./AdminContract2022List.vue?vue&type=script&lang=js"
import style0 from "./AdminContract2022List.vue?vue&type=style&index=0&id=50f6999d&prod&lang=scss&scoped=true"
import style1 from "./AdminContract2022List.vue?vue&type=style&index=1&id=50f6999d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f6999d",
  null
  
)

export default component.exports